import React, { useState, useEffect } from "react"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"

export default function PragmaticZombieSchool() {
  const data = promotionsData.find(
    (promo) => promo.title === "Pragmatic Play Zombie School"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title> Pragmatic Play Zombie School </title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/"> Promotions </a> /{" "}
              <span> {data.title} </span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1> Pragmatic Daily Tournaments </h1>
                <h2> Zombie School Megaways & Jackpot Blaze </h2>
                <div className="promotion-tnc-period">
                  <strong> Promo Period: </strong>
                  <span>
                    <br />
                    August 29, 2025 - September 13, 2025 (GMT + 8)
                  </span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <div className="promotion-tnc-btn-wrapper">
                  <a
                    href="/slots/?provider=PP"
                    className="promotion-cta-btn"
                    style={{ cursor: "pointer" }}
                  >
                    Play Now
                  </a>
                </div>
                <strong> Terms and Conditions: </strong>
                <ol>
                  <li>
                    <p>
                      75,000 winners will win cash prizes worth ₱62,553,000 from
                      29 August 2025, 20:00 to 13 September 2025, 00:59 (GMT+8).
                    </p>
                  </li>
                  <li>
                    <p>
                      Daily tournaments will run from 20:00 to 00:59 (GMT+8),
                      with 5,000 daily winners and prizes worth ₱4,170,200.
                      There will be a total of 15 tournaments during the
                      promotion period.
                    </p>
                  </li>
                  <li>
                    <p>
                      Winners are based on Largest win from a single spin
                      (adjusted for bet value).
                    </p>
                  </li>
                  <li>
                    <p>
                      Scores = (Largest single win during tournament)/(winning
                      bet during tournament)*100
                    </p>
                    <ul>
                      <li>
                        Player 1: bet $1 - win $50 (score = $50 / $1 * 100 =
                        5,000)
                      </li>
                      <li>
                        Player 2: bet $1 - win $5 (score = $5 / $1 * 100 = 500)
                      </li>
                    </ul>
                  </li>
                  <li>
                    <p>No minimum bet is required for this promotion.</p>
                  </li>
                  <li>
                    <p>
                      Players will win prizes in the form of a multiplier of the
                      winning player’s bet amount as set out in the prize table.
                    </p>
                  </li>
                  <li>
                    <p>
                      If the winning spin exceeds ₱58, the prize will be paid
                      out based on a bet of ₱58 X multiplier received.
                    </p>
                  </li>
                  <li>
                    <p>
                      Qualified Games:{" "}
                      <strong className="highlight">
                        Zombie School Megaways
                      </strong>{" "}
                      & <strong className="highlight">Jackpot Blaze</strong>.
                    </p>

                    <MasterGamesList
                      qualifiedGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customQualifiedGames={[
                        {
                          provider: "pp",
                          gameName: "Zombie School Megaways",
                        },
                        {
                          provider: "pp",
                          gameName: "Jackpot Blaze",
                        },
                      ]}
                      rank="off"
                      limit={2}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  </li>
                  <li>
                    <p>
                      If there are two or more players with identical score in
                      tournament leaderboard, the player who scores it first
                      will get the higher position on the leaderboard.
                    </p>
                  </li>
                  <li>
                    <p>
                      The tournament leaderboard is built in the qualifying
                      games and updates in real time.
                    </p>
                  </li>
                </ol>
                <div className="table-wrapper">
                  <table
                    className="promotion-tnc-table"
                    style={{ minWidth: "0px" }}
                  >
                    <thead>
                      <th> Rank </th>
                      <th> Daily Prizes </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td> 1 </td>
                        <td> x5,000 </td>
                      </tr>
                      <tr>
                        <td> 2-3 </td>
                        <td> x2,000 </td>
                      </tr>
                      <tr>
                        <td> 4-5 </td>
                        <td> x1,000 </td>
                      </tr>
                      <tr>
                        <td> 6-20 </td>
                        <td> x500 </td>
                      </tr>
                      <tr>
                        <td> 21-50 </td>
                        <td> x200 </td>
                      </tr>
                      <tr>
                        <td> 51-200 </td>
                        <td> x100 </td>
                      </tr>
                      <tr>
                        <td> 201-500 </td>
                        <td> x50 </td>
                      </tr>
                      <tr>
                        <td> 501-1,500 </td>
                        <td> x20 </td>
                      </tr>
                      <tr>
                        <td> 1,501-10,000 </td>
                        <td> x8 </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="promotion-tnc-cta">
                  <a
                    href="https://pp88.asia/tl/jackpot-blaze-zombie-school-megaways-daily-tournaments/"
                    className="promotion-cta-btn"
                    target="_blank"
                  >
                    View Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
